import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { notificationEndpoints } from "@/features/notification/api/endpoints";
import type {
  NotificationLogDto,
  NotificationLogFilter,
} from "@/features/notification/api/dto";

/**
 * Historique paginé des envois (`POST /NotificationLogs/all` — les listes
 * sont en POST, guide §4.2). Lecture authentifiée : `mutateData` en queryFn,
 * la requête reste une query TanStack (cache, invalidation).
 * Rôles : flashpay-superadmin, flashpay-admin, flashpay-service.
 */
export const useNotificationLogs = (
  params: ListRequest<NotificationLogFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.NOTIFICATION_LOGS_LIST(params),
    queryFn: () =>
      mutateData({
        url: notificationEndpoints.logs.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<NotificationLogDto>>,
    enabled,
  });
